// İSG uzmanı portalı — Eğitim editörü form tipleri (RHF/Zod). Sayfa (TrainingEditorPage) ile
// quiz alt-bileşenleri (QuizEditor/QuizQuestionCard) bu tipi paylaşır — `useFormContext` ile
// tek kaynaktan.
//
// **⛔ correctOptionIndex — yalnız authoring (§16).** Doğru cevabın 0-tabanlı indeksi form
// modelinde YALNIZ bu editör bağlamında yaşar (İSG uzmanı authoring). Personel/mobil tamamlama
// (Faz B / parça 049) ASLA görmez — bu tip yalnız web-expert eğitim editörüne aittir.

/** Seçenek RHF alanı — `useFieldArray` obje gerektirir (ham string dizisi değil). */
export interface TrainingOptionForm {
  text: string;
}

/** Soru RHF alanı — metin + 2-5 seçenek + doğru cevap indeksi (radio → correctOptionIndex). */
export interface TrainingQuestionForm {
  text: string;
  options: TrainingOptionForm[];
  correctOptionIndex: number;
}

/** Eğitim editörü form değerleri (meta + quiz; video referansı form dışı yerel durumda). */
export interface TrainingEditorForm {
  title: string;
  description: string;
  passThreshold: number;
  isActive: boolean;
  questions: TrainingQuestionForm[];
}

/** Yeni boş soru — 2 seçenekli, doğru cevap ilk seçenek (radio varsayılanı). */
export function emptyQuestion(): TrainingQuestionForm {
  return { text: '', options: [{ text: '' }, { text: '' }], correctOptionIndex: 0 };
}

/** Bir soruda izin verilen seçenek aralığı (§16: 2-5). */
export const MIN_OPTIONS = 2;
export const MAX_OPTIONS = 5;
